//     This code was generated by a Reinforced.Typings tool.
//     Changes to this file may cause incorrect behavior and will be lost if
//     the code is regenerated.

export enum StoreProductsTableFilterColumn {
  hasMsProduct = 0,
  /** Only for Wildberries products. */
  isTrashed = 1
}
